import { render, staticRenderFns } from "./HiddenPost.vue?vue&type=template&id=4aea915b&scoped=true&"
import script from "./HiddenPost.vue?vue&type=script&lang=js&"
export * from "./HiddenPost.vue?vue&type=script&lang=js&"
import style0 from "./HiddenPost.vue?vue&type=style&index=0&id=4aea915b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea915b",
  null
  
)

export default component.exports